module.exports = __webpack_public_path__ + "img/fondo-banner-principal.3ba59293.png";